import { IDmLoaiThuNhapHocRequest } from "../../../model/request/category/dmLoaiThuNhapHocRequest";
import {
  IDmLoaiThuNhapHoc,
  IDmLoaiThuNhapHocViewModel,
} from "../../../model/respone/category/IDmLoaiThuNhapHoc";
import { IHeNganhChuyenNganhTheoDotNhapHoc } from "../../reducer-model/category/IDmLoaiThuNhapHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmLoaiThuNhapHocActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmLoaiThuNhapHocViewModel[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmLoaiThuNhapHoc,
  SAVE_SUCCESS: {} as IDmLoaiThuNhapHocViewModel,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  CHANGE_REQUEST: {} as IDmLoaiThuNhapHocRequest,

  SHOW_EDIT_MODAL: {} as undefined | IDmLoaiThuNhapHocViewModel,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],
  DELETE_MANY_START: [] as number[],
  DELETE_MANY_SUCCESS: undefined,
  DELETE_MANY_ERROR: "",

  LOAD_THEO_DOT_START: {} as IDmLoaiThuNhapHocRequest,
  LOAD_THEO_DOT_SUCCESS: {} as IDmLoaiThuNhapHoc[],
  LOAD_THEO_DOT_ERRR: "",

  LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_START: {} as IDmLoaiThuNhapHocRequest,
  LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_SUCCESS:
    {} as IHeNganhChuyenNganhTheoDotNhapHoc[],
  LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_ERRR: "",

  SAVE_MULTIPLE_START: {} as IDmLoaiThuNhapHoc[],
  SAVE_MULTIPLE_SUCCESS: {} as IDmLoaiThuNhapHoc[],
  SAVE_MULTIPLE_ERROR: "",

  CHANGE_VALUE: {} as any,
};
export const eDmLoaiThuNhapHocActionIds = generateActionTypeIds(
  eDmLoaiThuNhapHocActionsObj,
  "LOAI_THU_NHAP_HOC"
);
export type IDmLoaiThuNhapHocActionTypes = IGenericActionType<
  typeof eDmLoaiThuNhapHocActionsObj,
  "LOAI_THU_NHAP_HOC"
>;
